import { useCallback, useState } from 'react'
import Styles from '../ShapesTab.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { ChevronDown2, Transparency } from 'blaze-ui/icons'
import { Editor, SharedStyle, track } from '@tldraw/tldraw'
import { ChevronRightSmall } from 'blaze-ui/icons/24'
import { SliderField } from 'components/Design/SliderField/SliderField'
import { FrameShapeUtil } from 'components/VisualStudioPlayground/Shapes/FrameShape/FrameShapeUtil'
import { FrameShape } from 'components/VisualStudioPlayground/Shapes/FrameShape/Types'

interface Props {
  editor: Editor
  style: SharedStyle<number>
}

export const Opacity = track(({ editor, style }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const updateOpacity = useCallback(
    (newValue: number) => {
      editor.batch(() => {
        if (editor.isIn('select')) {
          editor.setOpacityForSelectedShapes(newValue)
        }
      })
    },
    [editor],
  )

  if (style.type === 'mixed') return null

  const onChange = (val: number) => {
    let newVal = val
    if (newVal < 0) newVal = 0
    if (newVal > 100) newVal = 100
    updateOpacity(newVal / 100)
  }

  const selectedShape = editor.getOnlySelectedShape()
  let styleValue = style.value
  if (selectedShape?.type === 'frame') {
    styleValue = (editor.getShapeUtil(selectedShape.type) as FrameShapeUtil).getOpacity(selectedShape as FrameShape)
  }

  const value = Math.floor(styleValue * 100)

  return (
    <div className={Styles.colorSection}>
      <div className={Styles.actionRow} onClick={() => setIsExpanded(!isExpanded)}>
        <Transparency color="var(--selected-fill)" />
        <span className={Styles.actionName}>
          <Text variant="smallList">Opacity</Text>
        </span>
        <Text variant="secondary">{value}%</Text>
        {isExpanded ? <ChevronDown2 color="var(--dark-60)" /> : <ChevronRightSmall size={20} color="var(--dark-60)" />}
      </div>
      {isExpanded && (
        <div className={Styles.expandedSection}>
          <SliderField size="xs" value={value} minValue={0} maxValue={100} onChange={onChange} label="Opacity" />
        </div>
      )}
    </div>
  )
})
